import { render, staticRenderFns } from "./edit-mock-data.vue?vue&type=template&id=6d3e7b07&scoped=true&"
import script from "./edit-mock-data.vue?vue&type=script&lang=js&"
export * from "./edit-mock-data.vue?vue&type=script&lang=js&"
import style0 from "./edit-mock-data.vue?vue&type=style&index=0&id=6d3e7b07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3e7b07",
  null
  
)

export default component.exports